//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 14/07/2025
// Version : 1
// Description : Total de repuestos despachados por planta.
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState } from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import { UrlApi } from "../../../services/apirest";
import Dialog_total from "./Dialog_total";

function Total_x_planta() {
  const [datosGrafico, setDatosGrafico] = useState([]);
  const [busquedaRealizada, setBusquedaRealizada] = useState(false);
  //------------------ Dialog --------------------------//
  const [abrirDialog, setAbrirDialog] = useState(false);

  const handleOpenDialog = () => {
    setAbrirDialog(true);
  };

  const handleCloseDialog = () => {
    setAbrirDialog(false);
  };

  function generarColores(cantidad) {
    const colores = [];
    for (let i = 0; i < cantidad; i++) {
      const hue = Math.floor((360 / cantidad) * i);
      colores.push(`hsl(${hue}, 70%, 50%)`); // saturación 70%, luminosidad 50%
    }
    return colores;
  }

  const handleBuscar = () => {
    fetch(`${UrlApi}/estadisticas/totalXplanta`)
      .then((res) => res.json())
      .then((data) => {
        if (!Array.isArray(data)) {
          console.error("Respuesta inválida del servidor:", data);
          return;
        }

        // Lista de sucursales origen únicas
        const sucursalesOrigen = data.map((item) => item.nombre_origen);
        const coloresGenerados = generarColores(sucursalesOrigen.length);

        // Preparar dataset para el gráfico
        const dataset = data.map((item) => ({
          sucursal: item.nombre_origen,
          cantidad: item.total_enviado,
        }));

        setDatosGrafico({
          dataset,
          sucursales: sucursalesOrigen,
          colores: coloresGenerados,
        });
        setBusquedaRealizada(true);
        setAbrirDialog(true);
      })
      .catch((error) => {
        console.error("Error al obtener datos:", error);
      });
  };

  return (
    <div>
      <Grid container padding={3} spacing={2} alignItems="center">
        {" "}
        <Grid item xs={12}>
          <Typography
            align="center"
            style={{
              fontWeight: "bold",
              fontSize: 20,
              flexGrow: 1,
              textAlign: "center",
            }}
          >
            Total de stock despachados
          </Typography>
          {/* BOTÓN */}
          <Box display="flex" justifyContent="center" marginTop={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleBuscar}
              sx={{ height: 40 }}
            >
              Generar Gráfico
            </Button>
          </Box>
        </Grid>
      </Grid>
      {abrirDialog ? (
        <Dialog_total
          abrirDialog={abrirDialog}
          onClose={handleCloseDialog}
          datosGrafico={datosGrafico}
        />
      ) : null}
    </div>
  );
}

export default Total_x_planta;
